import React from 'react'
import styled from 'styled-components'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from 'react-i18next'

export const NoRecordFound = styled(({ className, leftMargin }) => {
  const { t } = useTranslation()
  return (
    <div className={className}>
      <Typography variant='h5'>
        {t('common.label.noRecordFound', 'No Record Found.')}
      </Typography>
    </div>
  )
})`
  white-space: nowrap;
  margin-top: 8px;
  margin-left: ${props => (props.leftMargin ? props.leftMargin : '0px')};
`
